/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
document.addEventListener("DOMContentLoaded", function () {
    const priceListEl = document.querySelector(".ProductMeta__PriceList.Heading");

    if (!priceListEl) return;

    const priceEl = priceListEl.querySelector(".Price--highlight");
    const compareEl = priceListEl.querySelector(".Price--compareAt");

    if (priceEl && compareEl) {
        let price = parseFloat(priceEl.innerText.replace(/[^0-9.]/g, ""));
        let compare = parseFloat(compareEl.innerText.replace(/[^0-9.]/g, ""));

        if (compare > price) {
            let savings = (compare - price).toFixed(0);

            // Create the new element
            let savingsEl = document.createElement("span");
            savingsEl.className = "Price--savings";
            savingsEl.innerText = `$${savings} Savings`;

            // Insert BEFORE the highlight price
            priceListEl.insertBefore(savingsEl, priceEl);
        }
    }
});
